import React from 'react';
// import './App.css';
import MapChart from './js/Map.js';
import BarChart from './js/Bar.js';
import TextChart from './js/Text.js';
import WordCloud from './js/WordCloud.js';
import {Container, Row, Col, Button} from 'react-bootstrap';
import avgDelay from './AvgDelay.json';
import usState from './js/us-state.json';
// import loadJsonFile from 'load-json-file';
import airlines_dict from './js/airlines_dict.json';
import * as d3 from 'd3';



const stateMap = {};
Object.keys(usState).forEach((key) => {
  stateMap[usState[key]] = key;
});

class App extends React.Component {
  constructor() {
    super()
    this.state = {
      airports: null,
      airportsSlice: null,
      avgDelay: null,
      text: null,
      tweets: null,
      airlines_dict: Object.assign(airlines_dict),
    }
    this.handleMapStateClick = this.handleMapStateClick.bind(this);
    this.handleShowAllAirports = this.handleShowAllAirports.bind(this);
    this.handleAirportClick = this.handleAirportClick.bind(this);
    this.handleAirlineClick = this.handleAirlineClick.bind(this);
  }
  
  componentDidMount() {
      const url = ["https://aukt2i8vp5.execute-api.us-east-1.amazonaws.com/Prod/main"]
      const opts = {"type": "basic"};

      Promise.all([
        fetch(url[0], {
          method: 'post',
          body: JSON.stringify(opts)
        })
        .then(data => data.json()),
      ])
      .then((results) => {
        this.setState({
          airports: JSON.parse(JSON.parse(results[0].airports)),
          airportsSlice: JSON.parse(JSON.parse(results[0].airports)),
          avgDelay: avgDelay,
        });
      });
  }

  handleShowAllAirports() {

    this.setState({
      airportsSlice: this.state.airports,
      avgDelay: avgDelay,
      
    })  
  }

  handleAirlineClick(airline) {
    const url = ["https://aukt2i8vp5.execute-api.us-east-1.amazonaws.com/Prod/main"]
    const opts = {"type": "queryTweets", "airline": this.state.airlines_dict[airline], "isAll": false};
    const opts2 = {"type": "findOneTweet", "airline": this.state.airlines_dict[airline], "isAll": false};

    Promise.all([
      fetch(url[0], {
        method: 'post',
        body: JSON.stringify(opts)
      })
      .then(data => data.json())
      .catch((e) => console.log(e)),
      fetch(url[0], {
        method: 'post',
        body: JSON.stringify(opts2)
      })
      .then(data => data.json())
      .catch((e) => console.log(e)),
    ])
    .then((results) => {
      
      const data = JSON.parse(JSON.parse(results[0].tweets));

      const tweet = JSON.parse(JSON.parse(results[1].tweets)).text;
      
      // console.log(text)
      const tweets = data.map((item) => {
        if (item.text === "🙏") {
          item.frequency = 0
        }
        return item
      })
      // console.log(tweets)
      this.setState({
        tweets: tweets,
        text: tweet.split(),
      })
    });

  }

  handleAirportClick(airport) {
    const airports = [];
    airports.push(airport.IATA_CODE);

    const url = ["https://aukt2i8vp5.execute-api.us-east-1.amazonaws.com/Prod/main"]
    const opts = {"type": "queryAirports", "isDeparture": true, "airports": airports };

    Promise.all([
      fetch(url[0], {
        method: 'post',
        body: JSON.stringify(opts)
      })
      .then(data => data.json())
      .catch((e) => console.log(e)),
    ])
    .then((results) => {
      
      const data = JSON.parse(JSON.parse(results[0].delay));
      data.forEach((item) => {
        // Todo...
        for (const [key, value] of Object.entries(item)) {
          if (!isNaN(value) && value < 0) {
            item[key] = 0;
          } 
        }
        item["AvgTotal"] = item["avgArrivalDelay"] + item["avgDepartureDelay"]
      })
      this.setState({
        avgDelay: data,
      })
    });
  }

  handleMapStateClick(state) {
    var filtered = this.state.airports.filter(function(d) {
        return (d.STATE === state);
    })

    const airports = [];
    filtered.forEach((item) => {
      // Todo...
      airports.push(item.IATA_CODE)
    });

    const url = ["https://aukt2i8vp5.execute-api.us-east-1.amazonaws.com/Prod/main"]
    const opts = {"type": "queryAirports", "isDeparture": true, "airports": airports};
    const opts2 = {"type": "findOneTweet", "airline": "", "isAll": true};

    Promise.all([
      fetch(url[0], {
        method: 'post',
        body: JSON.stringify(opts)
      })
      .then(data => data.json())
      .catch((e) => console.log(e)),
      fetch(url[0], {
        method: 'post',
        body: JSON.stringify(opts2)
      })
      .then(data => data.json())
      .catch((e) => console.log(e))
    ])
    .then((results) => {
      const data = JSON.parse(JSON.parse(results[0].delay));
      const tweet = JSON.parse(JSON.parse(results[1].tweets));
      
      data.forEach((item) => {
        // Todo...
        for (const [key, value] of Object.entries(item)) {
          if (!isNaN(value) && value < 0) {
            item[key] = 0;
          } 
        }
        item["AvgTotal"] = item["avgArrivalDelay"] + item["avgDepartureDelay"]
      })
      this.setState({
        avgDelay: data,
        airportsSlice: filtered,
        text: tweet.text.split(),
      })
    });

  }

  render() {
    if (!this.state.airports) return null;

    return (
      <React.Fragment>
          <div id="barTooltip" className="bar-tooltip" />
          <Row className="justify-content-md-center"> 
            <Col md="auto" > 
              <Button variant="outline-info" onClick={this.handleShowAllAirports}> Show all airports </Button>
            </Col>
          </Row>
          <Row>
            <TextChart text={this.state.text} />
          </Row>
          <Row>
            <Col md={6}>
              <MapChart 
              stateMap={stateMap} 
              airports={this.state.airportsSlice}
              onStateClick={this.handleMapStateClick}
              onAirportClick={this.handleAirportClick}/>
            </Col>
            <Col md={4}>
                
                <WordCloud 
                  tweets={this.state.tweets}
                  />


                <BarChart 
                  avgDelay={this.state.avgDelay}
                  onClickAirline={this.handleAirlineClick}/>
              
            </Col>
          </Row>


          
        
         
      </React.Fragment>
    );
  }
  
}

export default App;
